export default __webpack_public_path__ + "static/media/rightArrow.ab0bac55.svg";